import request from '@/utils/request'

export function pesticideList(params) {
  return request({ url: `/pesticides/`, method: 'get', params })
}

export function pesticideCreate(data) {
  return request({ url: `/pesticides/`, method: 'post', data })
}

export function pesticideUpdate(data) {
  return request({ url: `/pesticides/${data.id}/`, method: 'put', data })
}

export function pesticideDestroy(data) {
  return request({ url: `/pesticides/${data.id}/`, method: 'delete', data })
}

export function pesticideMeta() {
  return request({ url: `/pesticides/meta/`, method: 'get' })
}

function handbookApi(resource) {
  return {
    list: (params) => request({ url: `/${resource}/`, method: 'get', params }),
    create: (data) => request({ url: `/${resource}/`, method: 'post', data }),
    update: (data) => request({ url: `/${resource}/${data.id}/`, method: 'put', data }),
    destroy: (data) => request({ url: `/${resource}/${data.id}/`, method: 'delete', data }),
    meta: () => request({ url: `/${resource}/meta/`, method: 'get' }),
    detail: (id) => request({ url: `/${resource}/${id}/`, method: 'get' }),
  }
}

export const weedApi = handbookApi('weeds')
export const pestApi = handbookApi('pests')
export const diseaseApi = handbookApi('diseases')

export function plantProtectUpload(formData) {
  return request({
    url: `/plant_protect/upload/`,
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
